import { html, unsafeCSS } from 'lit';
import { BaseElement, customElement } from '../base-element';
import styles from './nav-links.scss?inline';

@customElement('ps-nav-links')
export class NavLinksWC extends BaseElement {
  static styles = unsafeCSS(styles);

  render() {
    return html`
      <div class="c-nav-links">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-nav-links': NavLinksWC;
  }
  enum PSElementTagNameMap {
    'ps-nav-links' = 'ps-nav-links',
  }
}
